import { Copy } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

/** Bulk action that needs no backend: copy the selected ids (for tickets, queries, hand-offs). */
export function CopyIdsButton({ ids }: { ids: string[] }) {
  return (
    <Button
      size="xs"
      variant="outline"
      onClick={() => void navigator.clipboard?.writeText(ids.join("\n")).then(() => toast.success(`Copied ${ids.length} ID${ids.length === 1 ? "" : "s"}`))}
    >
      <Copy data-icon="inline-start" />
      Copy IDs
    </Button>
  );
}
